import styled from "styled-components";

export const OurServicesCompWrapper = styled.div`
  .our_service_heading {
    margin-bottom: 45px;
    @media (max-width: 1199px) {
      margin-bottom: 25px;
    }
    @media (max-width: 899px) {
      margin-bottom: 20px;
    }
    h2 {
      margin-bottom: 0;
    }
  }
  .services_Cards_row {
    gap: 30px;
    .services_col {
      width: 100%;
      figure {
        img {
          object-fit: cover;
        }
      }
      .details_text_div {
        max-width: 80%;
        @media (max-width: 899px) {
          max-width: 100%;
        }
      }
    }
  }
  .small_card_row {
    margin: -10px;
    margin-top: 30px;
    @media (max-width: 899px) {
      margin-top: 20px;
    }
    .smCard_col {
      padding: 10px;
      width: 25%;
      @media (max-width: 899px) {
        width: 50%;
      }
      @media (max-width: 479px) {
        width: 100%;
      }
    }
  }
`;
